module.exports = __webpack_public_path__ + "img/icon-payment-money.d76effb1.svg";